import React from "react";

import Introduction from "content/Help/Introduction";
import Administration from "content/Help/Administration";
import AddNewUser from "content/Help/AddNewUser";
import EmailingUserCredentials from "content/Help/EmailingUserCredentials";
import ViewingUsers from "content/Help/ViewingUsers";
import EditingAndUpdatingUsers from "content/Help/EditingAndUpdatingUsers";
import DeletingUsers from "content/Help/DeletingUsers";
import ShowingUserProgress from "content/Help/ShowingUserProgress";
import ReportsSummary from "content/Help/ReportsSummary";
import ReportsProgress from "content/Help/ReportsProgress";
import ReportsEvents from "content/Help/ReportsEvents";
import EditCustomisableItems from "content/Help/EditCustomisableItems";
import EditingResources from "content/Help/EditingResources";
import EditEmailTemplates from "content/Help/EditEmailTemplates";

const helpPagination = [
  {
    title: "Introduction",
    content: <Introduction />,
  },
  {
    title: "Administration",
    content: <Administration />,
  },
  {
    title: "User Administration",
    subpages: [
      {
        title: "Adding a New User",
        content: <AddNewUser />,
        subpages: [
          {
            title: "Emailing User Credentials",
            content: <EmailingUserCredentials />,
          },
        ],
      },
      {
        title: "Viewing Users",
        content: <ViewingUsers />,
      },
      {
        title: "Editing and Updating Users",
        content: <EditingAndUpdatingUsers />,
      },
      {
        title: "Showing User Progress",
        content: <ShowingUserProgress />,
      },
      {
        title: "Deleting Users",
        content: <DeletingUsers />,
      },
    ],
  },
  {
    title: "Reports",
    subpages: [
      {
        title: "Summary",
        content: <ReportsSummary />,
      },
      {
        title: "Progress Report",
        content: <ReportsProgress />,
      },
      {
        title: "Events Report",
        content: <ReportsEvents />,
      },
    ],
  },
  {
    title: "Customisation",
    subpages: [
      {
        title: "Editing Resources",
        content: <EditingResources />,
      },
      {
        title: "Edit Customisable Items",
        content: <EditCustomisableItems />,
      },
      {
        title: "Editing Email Templates",
        content: <EditEmailTemplates />,
      },
    ],
  },
];

export default helpPagination;
